import { Button, Card, CircularProgress, Divider, Grid } from '@mui/material';
import React from 'react';
import { translate } from 'translate';

const GridForm = ({ children, onSubmit, name, loading, title }) => {
  return (
    <div className="m-7">
      <div className="mb-7">
        {/* <Breadcrumb
              routeSegments={[
                  { name: 'Material', path: '/material' },
                  { name: 'Table' },
              ]}
          /> */}
      </div>
      <Card>
        <div className="p-4">
          <h4>{title}</h4>
        </div>
        <Divider />
        <div className="p-4">
          <form onSubmit={onSubmit}>
            <Grid container spacing={3} alignItems="center">
              {children}
            </Grid>
            <div className="mt-3">
              {loading ? (
                <CircularProgress />
              ) : (
                <Button color="primary" variant="contained" type="submit">
                  {translate('Submit')}
                </Button>
              )}
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default GridForm;
